const messages: Record<string, string> = {
	'landing.headline.policyCheck': 'Oględziny pojazdu w kilku krokach:',
	'fourDiagonalPerspectives.vehicleFrontRight.title': 'Prawa przednia strona pojazdu',
	'fourDiagonalPerspectives.vehicleRearRight.title': 'Prawa tylna strona pojazdu',
	'fourDiagonalPerspectives.vehicleRearLeft.title': 'Lewa tylna strona pojazdu',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': 'Lewa przednia strona pojazdu',
	'waitForAudit.description.damageFound':
		'Dziękujemy za przesłanie dokumentacji. Nasz ekspert podejmie decyzję w ciągu maksymalnie 1 dnia roboczego, o wynikach poinformujemy odrębnym sms-em i/lub emailem.',
	'waitForAudit.description.damageNotFound':
		'Dziękujemy za przesłanie dokumentacji. Nasz ekspert podejmie decyzję w ciągu maksymalnie 1 dnia roboczego, o wynikach poinformujemy odrębnym sms-em i/lub emailem.',
	'button.start': 'Dalej',

	'invalidFile.size.title': 'Nieprawidłowy rozmiar zdjęcia',
	'invalidFile.size.description': 'Zdjęcie jest większe niż maksymalny dozwolony rozmiar.',
	'invalidFile.extension.title': 'Nieobsługiwany typ pliku',
	'invalidFile.extension.description':
		'Podany typ pliku nie jest obsługiwany. Obsługiwane typy plików: .jpg, .jpeg, .jfif, .heic, .heif, .png oraz .bmp',
};

export default messages;
